function setSegmentation() {
	return true;
	if (!localStorage) return;

	var tg = localStorage.getItem('abt5tg');
	var td = localStorage.getItem('abt5td');

	if (!tg || td < (new Date()).getTime()) {
		if (location.search.indexOf('gclid=') > -1
			||
			!document.referrer
			||
			navigator.userAgent.toLowerCase().indexOf('firefox') > -1
			||
			window.safari
			||
			screen.width <= 900
		) {
			tg = 'true';
		} else {
			tg = 'false';
		}
		localStorage.setItem('abt5tg', tg);
		var tomorrow = new Date();
		tomorrow.setHours(tomorrow.getMinutes() + 30);
		localStorage.setItem('abt5td', tomorrow.getTime());
	}
	
	return tg;
}
window.segmentedUser = setSegmentation();

export default setSegmentation;
